import React from "react";
import { Grid } from "Components/Base/Layout";
import SelectFilter from "./SelectFilter";
import {
  STYLE_GRID_ITEM,
  STYLE_DATE_FILTER,
  STYLE_SELECT_FILTER,
} from "../../styles";

const SessionFilters = ({
  languageContext,
  uniqueRegions,
  uniqueCities,
  sessionRegion,
  sessionCity,
  onChange,
  isMobile,
  totalFilterGroupsCount,
}) => (
  <>
    {uniqueRegions.length > 0 && (
      <Grid className="filter-grid-item" item xs={12} sx={STYLE_GRID_ITEM}>
        <SelectFilter
          key="sessionRegion"
          label={languageContext("region")}
          value={sessionRegion}
          onChange={onChange}
          menuItems={uniqueRegions.map((region) => ({
            title: region,
            value: region,
          }))}
          defaultMenuItemLabel={languageContext("all")}
          categoryName="sessionRegion"
          name="sessionRegion"
          sx={isMobile ? { marginBottom: 1 } : STYLE_DATE_FILTER}
          isMobile={isMobile}
          totalFilterGroupsCount={totalFilterGroupsCount}
          alwaysExpanded={true}
        />
      </Grid>
    )}
    {uniqueCities.length > 0 && (
      <Grid className="filter-grid-item" item xs={12} sx={STYLE_GRID_ITEM}>
        <SelectFilter
          key="sessionCity"
          label={languageContext("city")}
          value={sessionCity}
          onChange={onChange}
          defaultMenuItemLabel={languageContext("all")}
          menuItems={uniqueCities.map((city) => ({
            title: city,
            value: city,
          }))}
          categoryName="sessionCity"
          name="sessionCity"
          sx={isMobile ? { marginBottom: 1 } : STYLE_SELECT_FILTER}
          isMobile={isMobile}
          totalFilterGroupsCount={totalFilterGroupsCount}
          alwaysExpanded={true}
        />
      </Grid>
    )}
  </>
);

export default SessionFilters;
